export default "__VITE_ASSET__B90Ok82o__"